// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"306":"b4936fff","651":"e16e64fd"}[chunkId] + ".chunk.js";
};